<div class="pageWrapper">
  <div class="formsDetails rfq">
    <div class="archive-button-container">
      <div
        class="searchBox-saved-rfq"
        (click)="getArchiveRfqsList()"
        *ngIf="!isArchive"
      >
        Archives
      </div>
      <div
        class="searchBox-saved-rfq text-decoration-none"
        (click)="getInProgressRfqsList()"
        *ngIf="isArchive"
      >
        Back
      </div>
    </div>
    <section class="rfq-upper-section">
      <div class="searchBox-section">
        <!-- <h3 class="page-title">{{status == 'QUOTE_IN_PROGRESS' ? 'Quotes in Progress' : status == 'DRAFT' ?  'Drafts' : 'Archives'
}}</h3> -->
        <h3 class="page-title">{{ getStatusLabel(status) }}</h3>
        <form class="searchBox">
          <mat-icon class="iconColor">search</mat-icon>
          <input
            id="modules_rfq_leadmanagement_1"
            type="text"
            class="searchBox-input"
            placeholder="Search By Project Name"
            #textSearch
            (keyup)="searchRFQBy($event)"
          />
          <span
            class="clear-icon"
            *ngIf="textSearch.value"
            (click)="textSearch.value = ''; clearTextSearch()"
            ><mat-icon>clear</mat-icon></span
          >
        </form>
        <!-- <button id="modules_rfq_leadmanagement_2" mat-icon-button [matMenuTriggerFor]="filterMenu" class="searchBox-filter-icon">
          <mat-icon *ngIf="filterIdsList.length == 0">tune</mat-icon>
          <mat-icon *ngIf="filterIdsList.length">filter_alt</mat-icon>
        </button>
        <mat-menu #filterMenu="matMenu" class="rfq-filter-menu">
          <app-common-filter (filterSearch)="filterSearch($event)" [access]="'customer_approval_user'"  [baseInfo]="baseInfo"></app-common-filter>
        </mat-menu> -->
      </div>

      <div class="saved-rfq-button">
        <div class="formGroup rfq-select-box">
          <mat-form-field appearance="outline">
            <!-- <mat-label>Select RFQ</mat-label> -->
            <mat-select
              [formControl]="rfqFormControl"
              placeholder="Select RFQ"
              (selectionChange)="getRFQtemplateType(rfqFormControl)"
            >
              <mat-select-trigger>
                {{ rfqFormControl.value }}
              </mat-select-trigger>
              <mat-option
                *ngFor="let rfqType of rfqTemplateTypes"
                [value]="rfqType.value"
                >{{ rfqType.label }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <button
          id="modules_rfq_leadmanagement_3"
          mat-button
          class="new-rfq-button"
          routerLink="create-rfq/add"
        >
          + New RFQ
        </button>
        <button
          id="modules_rfq_leadmanagement_4"
          mat-button
          class="drafts-button"
          *ngIf="!isDraft"
          (click)="getDraftRfqsList()"
        >
          Drafts <span class="rfq-count">{{ totalDraftRfq }}</span>
        </button>
        <button
          id="modules_rfq_leadmanagement_5"
          mat-button
          class="drafts-button"
          *ngIf="isDraft"
          (click)="getInProgressRfqsList()"
        >
          Back
        </button>
      </div>
    </section>
    <!-- <cdk-virtual-scroll-viewport itemSize="5" class="example-viewport" (scrolledIndexChange)="currentIndex($event)"> -->

    <!-- for paginator -->
    <ng-container *ngIf="rfqList?.length; else noRfqFoundTemplate">
      <div
        class="lead-management-list-wrapper"
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="500"
        (scrolled)="onScroll()"
        [scrollWindow]="false"
      >
        <mat-card
          *ngFor="let rfq of rfqList; trackBy: trackCourse"
          class="rfq-card"
        >
          <mat-card-header>
            <div class="rfq-item rfq-icon">
              <svg
                width="31"
                height="35"
                viewBox="0 0 31 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.7831 33.5H4.93801C2.76309 33.5 0.999986 31.7091 1 29.5L1.00015 5.49999C1.00017 3.29085 2.76328 1.5 4.93818 1.5H22.6597C24.8346 1.5 26.5978 3.29087 26.5978 5.50001V13.5M7.89216 9.50002H19.7062M7.89216 15.5H19.7062M19.7062 23.4233V28.3306C19.7062 30.7556 22.2518 32.9797 24.6392 32.9797C27.0266 32.9797 29.5513 30.7556 29.5513 28.3306V22.1319C29.5513 20.8481 28.8247 19.5453 27.2084 19.5453C25.4794 19.5453 24.6392 20.8481 24.6392 22.1319V28.0724M7.89216 21.5001H13.7992"
                  stroke="#9B9B9B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="rfq-item rfq-title-expiry">
              <mat-card-title>
                <span class="subLabel font-12 medium">Project: </span>
                <span class="project_name" matTooltip="{{ rfq.projectName }}">
                  {{ rfq.projectName }}
                </span>
              </mat-card-title>
              <mat-card-subtitle>
                <span class="subLabel font-12 medium">RFQ ID: </span>
                {{ rfq.id }}
              </mat-card-subtitle>
              <mat-card-subtitle>
                <span class="subLabel font-12 medium">Created On: </span>
                {{ rfq.createdOn | date : "MMM d, y" }}
              </mat-card-subtitle>
            </div>
            <div class="rfq-status">
              <span class="info_bar">{{
                getRFQTemplateLabel(rfq?.rfqTemplate)
              }}</span>
            </div>
            <!-- <div class="rfq-item rfq-customer-id">
              <mat-card-title><span class="subLabel font-12 medium">Customer: {{ rfq.customerName }}</span></mat-card-title>
              <mat-card-subtitle>
                <span class="subLabel font-12 medium">Cust ID: {{rfq.customerId}}</span>
              </mat-card-subtitle>
            </div> -->
            <div class="rfq-item rfq-capabilities">
              <div class="font-10 medium mb-4">
                <span class="subLabel">Category</span>
              </div>
              <ng-container
                *ngFor="
                  let cat of (
                    (rfq?.createdByShop ? rfq?.mroCategory : rfq?.category)
                    | categoryFormatter : 2
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfq?.createdByShop ? rfq?.mroCategory : rfq?.category)
                      | categoryFormatter : 2
                    ).tooltip
                  "
                >
                  {{ cat }}
                </span>
              </ng-container>
            </div>

            <div class="rfq-item rfq-sub-capabilities">
              <div
                class="font-10 medium mb-4"
                [ngClass]="{
                  'subCategory-align': rfq?.subCategory?.length == 0
                }"
              >
                <span class="subLabel">Sub-Category</span>
              </div>
              <ng-container
                *ngFor="
                  let subCategory of (
                    (rfq?.createdByShop
                      ? rfq?.mroSubCategory
                      : rfq?.subCategory
                    ) | categoryFormatter : 2 : rfq?.categoryOthers
                  ).display
                "
              >
                <span
                  class="capability"
                  [matTooltip]="
                    (
                      (rfq?.createdByShop
                        ? rfq?.mroSubCategory
                        : rfq?.subCategory
                      ) | categoryFormatter : 2 : rfq?.categoryOthers
                    ).tooltip
                  "
                >
                  {{ subCategory }}
                </span>
              </ng-container>
            </div>
            <div class="chatIco">
              <span (click)="loadChatBox($event, rfq.id, rfq.projectName)">
                <lucide-icon
                  [size]="18"
                  name="message-square"
                  class="lucid-icon"
                ></lucide-icon>
              </span>
            </div>
            <div class="rfq-status">
              <p class="status" [class]="rfq.status">
                <!-- {{ rfq.status == 'QUOTE_IN_PROGRESS' ? 'Quote in Progress' : rfq.status }} -->
                {{ getStatusLabel(rfq.status) }}
              </p>
            </div>
            <div
              class="rfq-bookmarked customer"
              (click)="bookmarkRFQ($event, rfq)"
              *ngIf="status !== 'RFQ_DISCONTINUED'"
            >
              <p *ngIf="rfq.pinned; else nonSavedRfq">
                <button
                  id="modules_rfq_leadmanagement_6"
                  mat-icon-button
                  class="rfq-saved"
                >
                  <lucide-icon name="Pin" class="icon active"></lucide-icon>
                </button>
              </p>
              <ng-template #nonSavedRfq>
                <button
                  id="modules_rfq_leadmanagement_7"
                  mat-icon-button
                  class="rfq-unsaved"
                >
                  <lucide-icon name="Pin" class="icon"></lucide-icon>
                </button>
              </ng-template>
            </div>

            <div class="rfq-view flex">
              <button
                *ngIf="rfq.status == RFQStatus.DRAFT"
                id="modules_rfq_leadmanagement_80"
                mat-icon-button
                (click)="openUpdteRfq(rfq)"
              >
                <lucide-icon name="pencil" class="RotateCw"></lucide-icon>
              </button>
              <!-- <button id="modules_rfq_leadmanagement_8" mat-icon-button (click)="openRfqQuote(rfq, $event)">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button> -->

              <button
                id="modules_rfq_leadmanagement_8"
                mat-icon-button
                (click)="viewRfqDetails($event, rfq.id, rfq.projectName)"
              >
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            </div>
          </mat-card-header>
        </mat-card>
      </div>
      <!-- <mat-paginator
        [pageSizeOptions]="PAGE_SIZE_OPTIONS"
        [length]="totalElements"
        [pageSize]="pageSize"
        (page)="pageChange($event)"
        class="paginator"
        aria-label="Select page of users"
      >
      </mat-paginator> -->
    </ng-container>
    <ng-template #noRfqFoundTemplate>
      <div class="no-result-container">No Result Found</div>
    </ng-template>

    <!-- </cdk-virtual-scroll-viewport> -->
    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator> -->
  </div>
</div>
<div
  class="overlayDrop"
  *ngIf="rightPanelActive"
  (click)="closeRfqQuote($event)"
></div>
<div
  class="layout-rightpanel"
  [ngClass]="{ 'layout-rightpanel-active': rightPanelActive }"
>
  <app-rfq-quote
    [rfqData]="selectedRfq"
    (childClick)="onChildClose()"
    (updateRfqList)="updateRfqListData($event)"
    *ngIf="rightPanelActive"
  ></app-rfq-quote>
</div>
<div *ngIf="rfqService.showDraftMessage && totalDraftRfq != 0">
  <div class="pickUpdraft">
    Pick up where you left off
    <a (click)="getDraftRfqsListPopup()">Open Draft </a>
    <span class="close" (click)="toggleVisibility()">x</span>
  </div>
</div>
<ng-container #dynamicContainer></ng-container>
